import React from "react";
import { Icon } from "semantic-ui-react";

const NavigationToggle = ({ onToggle }) => (
  <button id="mobile-toggle">
    <Icon name="content" size="large" onClick={onToggle} />
  </button>
);

export default NavigationToggle;



// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationToggle.jsx